import { z } from 'zod';
export const documentsInsuranceClaimsCompletionCapability = 'documents.insurance-claim-completion.v1';
export const documentsInsuranceClaimsCompletionSlot = 'insurance-claims.document-completion';
export const documentsInsuranceClaimsCompletionProviderId = 'documents.server.insurance-claims-completion';
const idSchema = z.string().uuid();
const countSchema = z.number().int().nonnegative();
export const documentsInsuranceClaimsCompletionRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(documentsInsuranceClaimsCompletionCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const documentsInsuranceClaimsCompletionResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(documentsInsuranceClaimsCompletionCapability),
    projectId: idSchema,
    sourceLinkedCount: countSchema,
    signedCount: countSchema,
    finalizedArtifactCount: countSchema,
    signedAndFinalizedCount: countSchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((value, context) => {
    if (value.signedCount > value.sourceLinkedCount) {
        context.addIssue({ code: 'custom', path: ['signedCount'], message: 'Signed documents cannot exceed source-linked documents.' });
    }
    if (value.finalizedArtifactCount > value.sourceLinkedCount) {
        context.addIssue({ code: 'custom', path: ['finalizedArtifactCount'], message: 'Finalized artifacts cannot exceed source-linked documents.' });
    }
    if (value.signedAndFinalizedCount > Math.min(value.signedCount, value.finalizedArtifactCount)) {
        context.addIssue({ code: 'custom', path: ['signedAndFinalizedCount'], message: 'Signed-and-finalized documents must be in both source sets.' });
    }
});
//# sourceMappingURL=documents-insurance-claims-completion.contract.js.map